import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Box from '../Box'

export const TextInputBox = forwardRef((props, ref) => {
  return (
    <Box
      variant="primary"
      variantPath="textInput"
      {...props}
      ref={ref}
      __css={{
        my: 1,
        p: 1,
        borderStyle: 'solid',
        borderWidth: 1,
        display: 'block',
        width: '100%',
        lineHeight: 1.4,
        ':focus': {
          outline: 'none',
        }
      }}
    />
  )
})

TextInputBox.displayName = 'TextInputBox'

export const TextInput = forwardRef((props, ref) => {
  return (
    <TextInputBox {...props} ref={ref} as="input" />
  )
})

TextInput.displayName = 'TextInput'

TextInput.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
}

TextInput.defaultProps = {
  type: 'text',
}

export default TextInput
